export default {
  tableHeader: {
    dataId: 'Feature',
    spearmanCorrelationCoeff: 'Non-linear correlation coefficient  (Spearman)',
    pearsonCorrelationCoeff: 'Linear correlation coefficient (Pearson)',
  },
};
